/*
 * NotFoundComp
 *
 */

import React from 'react';

import {
  Section,
  Container,
  H1,
} from '@landing_academy/shared';

/* eslint-disable max-len */
class NotFoundComp extends React.PureComponent {
  render() {
    return (
      <Section
        padding="126px 0 0"
        paddingmobile="76px 0 0"
      >
        <Container className="container">
          <H1 center>
            Pagina non trovata
          </H1>
          <p style={{ textAlign: 'center' }}>Torna alla <a href="/">home page</a></p>
        </Container>
      </Section>
    );
  }
}

export default NotFoundComp;
